import { useEffect } from 'react';

let opened = 0;
let previousOverflow = '';

const useModalScrollLock = (enabled = true) => {
    useEffect(() => {
        if (!enabled) return undefined;
        if (opened === 0) {
            previousOverflow = document.body.style.overflow;
            document.body.style.overflow = 'hidden';
        }
        opened += 1;
        return () => {
            opened -= 1;
            if (opened === 0) document.body.style.overflow = previousOverflow;
        };
    }, [enabled]);
};

export default useModalScrollLock;
